function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Artboard 1");

var SvgStation = function SvgStation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 116",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M0,112.2H200V3.8H0ZM6,9.8H194v96.4H6Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M14.5,52.1H126.1V23.6H14.5Zm5.9-22.6h99.7V46.1H20.4Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M188.5,22.5H134.4V51.1h54.1ZM140.3,45.1h0V28.5h42.1V45.1Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M28.6,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S31.3,35.3,28.6,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M112,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S114.7,35.3,112,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M42.5,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S45.2,35.3,42.5,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M56.4,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S59.1,35.3,56.4,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M70.3,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S73,35.3,70.3,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M84.2,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S86.9,35.3,84.2,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M98.1,35.3c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S100.8,35.3,98.1,35.3Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M176.3,66.5h0A12.7,12.7,0,1,0,189,79.2h0A12.72,12.72,0,0,0,176.3,66.5ZM183,79.2a6.7,6.7,0,1,1-13.4,0h0a6.7,6.7,0,0,1,6.7-6.7h0a6.72,6.72,0,0,1,6.7,6h0Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M147.5,66.5a12.7,12.7,0,1,0,12.7,12.7h0A12.72,12.72,0,0,0,147.5,66.5Zm6.7,12.7a6.7,6.7,0,0,1-6.7,6.7,6.8,6.8,0,0,1-6.4-4.7v-.1c0-.2-.1-.3-.1-.5v-.3a.63.63,0,0,0-.1-.4v-.7h0a6.65,6.65,0,1,1,13.3,0Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M14.5,93.4H126.1V65H14.5Zm5.9-22.5h99.7V87.5H20.4Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M28.6,76.7c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S31.3,76.7,28.6,76.7Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M112,76.7c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S114.7,76.7,112,76.7Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M42.5,76.7c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S45.2,76.7,42.5,76.7Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("ellipse", {
    cx: 56.4,
    cy: 79.2,
    rx: 4.9,
    ry: 2.5,
    style: {
      fill: "#fff"
    }
  }), React.createElement("ellipse", {
    cx: 70.3,
    cy: 79.2,
    rx: 4.9,
    ry: 2.5,
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M84.2,76.7c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S86.9,76.7,84.2,76.7Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M98.1,76.7c-2.7,0-4.9,1.1-4.9,2.5s2.2,2.5,4.9,2.5,4.9-1.1,4.9-2.5S100.8,76.7,98.1,76.7Z",
    style: {
      fill: "#fff"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/station.8ae3ddb0.svg";
export { ForwardRef as ReactComponent };